var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "179px",
    height: "179px",
    viewBox: "0 0 179 179",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fitbit_logo_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quiz-RD3.5-Feedback",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quiz-Calculating---Desktop",
    transform: "translate(-631.000000, -291.000000)",
    fill: "#20A7A9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calculating",
    transform: "translate(343.000000, 291.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fitbit_logo_RGB",
    transform: "translate(288.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9289444,78.5722986 C4.89266667,78.5722986 0,83.4662083 0,89.5024861 C0,95.5375208 4.89266667,100.431431 10.9289444,100.431431 C16.9652222,100.431431 21.8591319,95.5375208 21.8591319,89.5024861 C21.8591319,83.4662083 16.9652222,78.5722986 10.9289444,78.5722986 Z",
    id: "most-left"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4195,115.350583 C41.6908403,115.350583 36.2363125,120.805111 36.2363125,127.533771 C36.2363125,134.262431 41.6908403,139.716958 48.4195,139.716958 C55.1481597,139.716958 60.6026875,134.262431 60.6026875,127.533771 C60.6026875,120.805111 55.1481597,115.350583 48.4195,115.350583 Z",
    id: "3rd-left"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4195,76.7810556 C41.39375,76.7810556 35.6980694,82.4767361 35.6980694,89.5024861 C35.6980694,96.5282361 41.39375,102.222674 48.4195,102.222674 C55.44525,102.222674 61.1409306,96.5282361 61.1409306,89.5024861 C61.1409306,82.4767361 55.44525,76.7810556 48.4195,76.7810556 Z",
    id: "2nd-left"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4195,39.2842847 C41.6908403,39.2842847 36.2363125,44.7388125 36.2363125,51.4674722 C36.2363125,58.1961319 41.6908403,63.6506597 48.4195,63.6506597 C55.1481597,63.6506597 60.6026875,58.1961319 60.6026875,51.4674722 C60.6026875,44.7388125 55.1481597,39.2842847 48.4195,39.2842847 Z",
    id: "left-top"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.902354,71.4060833 C150.908187,71.4060833 142.805951,79.5070764 142.805951,89.5024861 C142.805951,99.4966528 150.908187,107.598889 160.902354,107.598889 C170.897764,107.598889 178.998757,99.4966528 178.998757,89.5024861 C178.998757,79.5070764 170.897764,71.4060833 160.902354,71.4060833 Z",
    id: "most-right"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.91209,111.766854 C114.204486,111.766854 107.145174,118.826167 107.145174,127.533771 C107.145174,136.241375 114.204486,143.300687 122.91209,143.300687 C131.619694,143.300687 138.679007,136.241375 138.679007,127.533771 C138.679007,118.826167 131.619694,111.766854 122.91209,111.766854 Z",
    id: "3rd-right"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.91209,73.1973264 C113.907396,73.1973264 106.606931,80.4965486 106.606931,89.5024861 C106.606931,98.5071806 113.907396,105.806403 122.91209,105.806403 C131.916785,105.806403 139.21725,98.5071806 139.21725,89.5024861 C139.21725,80.4965486 131.916785,73.1973264 122.91209,73.1973264 Z",
    id: "2nd-right"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.91209,35.7005556 C114.204486,35.7005556 107.145174,42.7598681 107.145174,51.4674722 C107.145174,60.1750764 114.204486,67.2343889 122.91209,67.2343889 C131.619694,67.2343889 138.679007,60.1750764 138.679007,51.4674722 C138.679007,42.7598681 131.619694,35.7005556 122.91209,35.7005556 Z",
    id: "right-top"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9063264,152.125139 C78.4852847,152.125139 72.4688958,158.140285 72.4688958,165.562569 C72.4688958,172.983611 78.4852847,179 85.9063264,179 C93.3286111,179 99.345,172.983611 99.345,165.562569 C99.345,158.140285 93.3286111,152.125139 85.9063264,152.125139 Z",
    id: "5th-middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9063264,113.558097 C78.1881944,113.558097 71.9318958,119.815639 71.9318958,127.533771 C71.9318958,135.251903 78.1881944,141.509444 85.9063264,141.509444 C93.6244583,141.509444 99.882,135.251903 99.882,127.533771 C99.882,119.815639 93.6244583,113.558097 85.9063264,113.558097 Z",
    id: "4th-middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9063264,74.9885694 C77.8911042,74.9885694 71.3936528,81.4872639 71.3936528,89.5024861 C71.3936528,97.5177083 77.8911042,104.01516 85.9063264,104.01516 C93.9215486,104.01516 100.420243,97.5177083 100.420243,89.5024861 C100.420243,81.4872639 93.9215486,74.9885694 85.9063264,74.9885694 Z",
    id: "3rd-middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9063264,37.4917986 C78.1881944,37.4917986 71.9318958,43.7493403 71.9318958,51.4674722 C71.9318958,59.1856042 78.1881944,65.4431458 85.9063264,65.4431458 C93.6244583,65.4431458 99.882,59.1856042 99.882,51.4674722 C99.882,43.7493403 93.6244583,37.4917986 85.9063264,37.4917986 Z",
    id: "2nd-middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.345,13.4386736 C99.345,20.8609583 93.3286111,26.8773472 85.9063264,26.8773472 C78.4852847,26.8773472 72.4688958,20.8609583 72.4688958,13.4386736 C72.4688958,6.01763194 78.4852847,0.00124305556 85.9063264,0.00124305556 C93.3286111,0.00124305556 99.345,6.01763194 99.345,13.4386736 L99.345,13.4386736 Z",
    id: "top-middle"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitbit);
export default __webpack_public_path__ + "static/media/fitbit.64aa1b08744bcee04a1660ec9f568a94.svg";
export { ForwardRef as ReactComponent };